<div fxLayout="row">

    <mat-form-field style="margin: 0 20px 20px 20px">
        <mat-label>Atividade:</mat-label>
        <mat-select [(ngModel)]="oficina.atividade.id" name="oficina_{{pinOficina}}" required
                    (selectionChange)="carregarDadosOficina()">
            <mat-option *ngFor="let i of oficinas" [value]="i.id">
                {{i.descricao}}
            </mat-option>
        </mat-select>
        <mat-hint *ngIf="oficinas?.length === 0" align="start">Nenhuma atividade cadastrada</mat-hint>
    </mat-form-field>

    <mat-form-field style="margin: 0 0 0 20px" fxFlex="15%">
        <input matInput name="dataInicio_{{pinDataInicio}}" (input)="onMascaraDataInput($event)"
            [matDatepicker]="dataInicioAtividade" placeholder="Data Início:" [(ngModel)]="oficina.dataInicioAtividade"
            required>
        <mat-datepicker-toggle matSuffix [for]="dataInicioAtividade"></mat-datepicker-toggle>
        <mat-datepicker #dataInicioAtividade></mat-datepicker>
    </mat-form-field>

    <mat-form-field style="margin: 0 0 0 20px" fxFlex="15%">
        <input matInput name="dataDesvinculacao_{{pinDataDesvinculacao}}"
               [min]="oficina.dataInicioAtividade"
               [matDatepicker]="dataDesvinculacao" placeholder="Data de desvinculação" (input)="onMascaraDataInput($event)"
               [(ngModel)]="oficina.dataDesvinculacao">
        <mat-datepicker-toggle matSuffix [for]="dataDesvinculacao"></mat-datepicker-toggle>
        <mat-datepicker #dataDesvinculacao></mat-datepicker>
    </mat-form-field>

    <mat-form-field style="margin: 0 0 0 20px" fxFlex="60%">
        <mat-label>Descrição desligamento:</mat-label>
        <input #descricao matInput name="descricao_{{pinDescricao}}" [(ngModel)]="oficina.descDesligamento"
            maxlength="200">
        <mat-hint align="start">{{descricao.value.length}} / 200</mat-hint>
    </mat-form-field>

    <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(oficina)"
            style="margin-bottom: 10px;">
        <mat-icon>delete</mat-icon>
    </button>

</div>
